import React from 'react';
import { FiMapPin, FiPhone, FiMail, FiAlertCircle, FiClock } from 'react-icons/fi';

const Contact = () => {
  return (
    <section id="contact" className="contact-reach-section">
      <div className="contact-reach-inner">
        {/* Section Header */}
        <div className="contact-reach-header">
          <span className="section-tag">Reach Us</span>
          <h2 className="section-title">Visit or reach us anytime</h2>
          <p className="section-subtitle">
            Whether you have a quick question or need directions, we are here to help you get the care you need.
          </p>
        </div>

        {/* Cards Row */}
        <div className="contact-reach-grid">

          {/* Card 1 — Location */}
          <div className="contact-reach-card">
            <div className="crcard-icon-wrap crcard-teal">
              <FiMapPin className="crcard-icon" />
            </div>
            <h3 className="crcard-title">Our Main Hospital</h3>
            <div className="crcard-body">
              <p className="crcard-hospital-name">Swarup Multi-Speciality Hospital</p>
              <p className="crcard-address">
                154, Azad Galli, Dudhali,<br />
                Near KMC College,<br />
                Kolhapur, Maharashtra — 416 003
              </p>
              <a
                href="https://maps.google.com/?q=Swarup+Hospital+Kolhapur"
                target="_blank"
                rel="noopener noreferrer"
                className="crcard-map-link"
              >
                <FiMapPin style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                Get Directions
              </a>
            </div>
          </div>

          {/* Card 2 — Contact Details */}
          <div className="contact-reach-card">
            <div className="crcard-icon-wrap crcard-teal">
              <FiPhone className="crcard-icon" />
            </div>
            <h3 className="crcard-title">Contact Details</h3>
            <div className="crcard-body">

              <div className="crcard-detail-row">
                <FiPhone className="crcard-row-icon" />
                <div>
                  <p className="crcard-row-label">Phone</p>
                  <a href="tel:+919373674641" className="crcard-row-value crcard-link">
                    +91 9373-67-4641
                  </a>
                </div>
              </div>

              <div className="crcard-detail-row">
                <FiMail className="crcard-row-icon" />
                <div>
                  <p className="crcard-row-label">Email</p>
                  <a href="mailto:swaruphospital154@gmail.com" className="crcard-row-value crcard-link">
                    swaruphospital154@gmail.com
                  </a>
                </div>
              </div>

              <div className="crcard-detail-row">
                <FiClock className="crcard-row-icon" />
                <div>
                  <p className="crcard-row-label">OPD Hours</p>
                  <p className="crcard-row-value">Mon – Sat: 9:00 AM – 8:00 PM</p>
                </div>
              </div>

              <div className="crcard-emergency-box">
                <FiAlertCircle className="crcard-emergency-icon" />
                <div>
                  <p className="crcard-emergency-label">Emergency</p>
                  <a href="tel:108" className="crcard-emergency-number">108 (24/7 Support)</a>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Contact;
